import {
  Box,
  Button,
  Grid,
  Typography,
  MenuItem,
  TextField,
} from "@mui/material";
import { useState } from "react";
import styles from "../InternalTracker.module.css";
import RootComponents from "../../../components/common/RootComponents";
import { customTextColor } from "../../../utils/const";
import { useNavigate } from "react-router-dom";
import { CiLinkedin } from "react-icons/ci";
import { PiBuildingsLight } from "react-icons/pi";
import { PiBookOpenUserLight } from "react-icons/pi";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { PiMapPinSimpleLineLight } from "react-icons/pi";
import { PiMapPinSimpleAreaLight } from "react-icons/pi";
import { PiInvoiceLight } from "react-icons/pi";
import { PiIdentificationCardLight } from "react-icons/pi";
import { PiAddressBookLight } from "react-icons/pi";

const work = [
    { value: 'on-site', label: 'On-site' },
    { value: 'hybrid', label: 'Hybrid' },
    { value: 'remote', label: 'Remote' },
  ];
  
  
  const passingYears = [
    { value: '2019', label: '2019' },
    { value: '2020', label: '2020' },
    { value: '2021', label: '2021' },
    { value: '2022', label: '2022' },
    { value: '2023', label: '2023' },
    { value: '2025', label: '2025' },
  ];
  
  const Years = [
    { value: '0-6', label: '0-6' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
  ];
  
  const time = [
    { value: 'pst', label: 'PST' },
    { value: 'mst', label: 'MST' },
    { value: 'cst', label: 'CST' },
    { value: 'pst', label: 'PST' },
  
  ];


const fieldStyle = {
    width: "100%",
    "& .MuiInputBase-root": {
      paddingLeft: "30px", // Adjust padding to make space for the icon
    },
    "& .MuiInputLabel-root": {
      left: "35px",
      fontSize: "14px ", // Adjust label position to align with input text
    },
    "& .MuiInputBase-input": {
      paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
    },
    "& .MuiInputLabel-shrink": {
      left: "35px",
      fontSize: "14px ", // Adjust label position when it shrinks
    },
    padding: "7px",
  };
  

const AddConsultantResume = () => {
  const navigate = useNavigate();
  


  return (
    // <RootComponents>
      <Box className={styles.candidate_structure}>
        <Typography
          className={styles.add_candidate_heading}
          style={{ color: customTextColor }}
        >
          Candidate Details
        </Typography>

        <Grid container className={styles.add_field_section}>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "10px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiBuildingsLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Work Preference"
              sx={fieldStyle}
              select
              variant="standard"
            >
              {work.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "10px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiInvoiceLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              label="Current Rate"
              sx={fieldStyle}
              variant="standard"
            ></TextField>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "10px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiMapPinSimpleAreaLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Time Zone"
              sx={fieldStyle}
              variant="standard"
            >
              {time.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "10px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Location in State"
              variant="standard"
              type="text"
              sx={fieldStyle}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "10px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiBuildingOfficeLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Current organization"
              variant="standard"
              type="text"
              sx={fieldStyle}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "10px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiAddressBookLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Industry and Domain "
              variant="standard"
              type="text"
              sx={fieldStyle}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "10px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiBookOpenUserLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              label="Qualification "
              variant="standard"
              select
              sx={fieldStyle}
            ></TextField>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "10px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiBuildingsLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="University"
              variant="standard"
              type="text"
              sx={fieldStyle}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "10px 10px 10px 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiIdentificationCardLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Rate/Salary"
              variant="standard"
              type="text"
              sx={fieldStyle}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "10px 10px 10px 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <CiLinkedin style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="LinkedIn URL"
              variant="standard"
              type="text"
              sx={fieldStyle}
            />
          </Grid>
        </Grid>

  

        <Box className={styles.add_candidate_btns}>
          <button
            onClick={() => navigate("/internal-tracker-add")}
            style={{ backgroundColor: "#1b89de ",  }}
          >
            Back
          </button>
          <button
            onClick={() => navigate("/internal-tracker-submit")}
            style={{ backgroundColor: "#3856a6 ",  }}
          >
            Skip & Next
          </button>
        </Box>
      </Box>
    // </RootComponents>
  );
};

export default AddConsultantResume;
